import {contactRoleNames,contactRoleView,contactRoleViewPatterns} from '@myfm/domain';
/** Role views filter relationships, never create a second contact identity. */
export {contactRoleNames,contactRoleView};
export function matchesContactRole(role:string,view:ReturnType<typeof contactRoleView>){
 if(!view)return true;
 return new RegExp(contactRoleViewPatterns[view],'i').test(role);
}
